<div class="container mx-auto" id="module-overview-component">
  <!-- Offer Overview Component -->
  <div class="mt-8">
    <!-- Grid Layout for Header -->
    <div class="grid sm:grid-cols-2 grid-cols-1">
      <!-- Title Section -->
      <div class="col-span-1 md:mb-0 mb-3">
        <h1 class="font-['Apex_Rounded_Medium'] lg:text-3xl text-xl">{{ "kam.moduleManagement.title" | translate }}</h1>
        <!-- Section Title -->
      </div>
      <!-- Button Section -->
      <div class="col-span-1 sm:text-end text-center md:mb-0 mb-3 md:text-base text-sm">
       <gate-add-module [claims]="claims"></gate-add-module>
      </div>
    </div>
  </div>
  <div class="mt-8">
    <gate-module-list [claims]="claims"></gate-module-list>
  </div>
</div>
